import { faCheckCircle, faCopy, faExclamationCircle, faMinusCircle, faPencil, faPlus, faSearch, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import React, { Component } from 'react';
import { Accordion, Badge, Button, Col, Form, InputGroup, Modal, Row, Table } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import XLSX from 'sheetjs-style';
import { GET, POST } from '../../api';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { handleFormErrors } from '../../helpers/form_helpers';
import { changeColorOpacity, DDL_ExamstypegrpTypes, DDL_ExamstypegrpTypes2, getUrlParam, uniqueByAttribute2 } from '../../helpers/general_helpers';
import { t } from '../../helpers/translation_helper';
var Chance = require('chance');
var chance = new Chance();

class TermAgegroupAssessment extends Component {

    searchFieldRef = React.createRef();
    state = {
        DDL_examstypegrp_types: DDL_ExamstypegrpTypes(),
        DDL_examstypegrp_types2: DDL_ExamstypegrpTypes2(),
        deleteModal: { show: false, id: 0, action: () => { } },
        modalTermAgegroup: {
            show: false,
            title: 'Assessment Percentage',
            toggle: (agegroup_id = null, acs_id = null) => this.setState({ modalTermAgegroup: { ...this.state.modalTermAgegroup, show: !this.state.modalTermAgegroup.show, selectedSubjects: [], selectedAgegroups: [] } }, () => {
                if (this.state.modalTermAgegroup.show) {
                    this.getTermAgegroupAssessment(agegroup_id, acs_id)
                }
            }),
            save: () => this.saveTermAgegroupAssessment(),
            selectedSubjects: [],
            selectedAgegroups: []
        },
        agegroup: [],
        examstypegrp: [],
        cdt: {
            fetching: false,
            search: '',
            uniqueAgegroups: [],
            columns: [
                {
                    id: 'term_linked_agegroup_assessment.tlaa_id',
                    column: 'tlaa_id',
                    name: 'Actions',
                    visibility: true
                },
                {
                    id: 'term_linked_agegroup_assessment.agegroup_code',
                    column: 'agegroup_code',
                    name: 'Grade',
                    visibility: true
                },
                {
                    id: 'term_linked_agegroup_assessment.acs_name',
                    column: 'acs_name',
                    name: 'Subject',
                    visibility: true
                },
                {
                    id: 'term_linked_agegroup_assessment.term_d_1',
                    column: 'term_d_1',
                    name: 'Term 1',
                    visibility: true
                },
                {
                    id: 'term_linked_agegroup_assessment.term_d_2',
                    column: 'term_d_2',
                    name: 'Term 2',
                    visibility: true
                },
                {
                    id: 'term_linked_agegroup_assessment.term_d_3',
                    column: 'term_d_3',
                    name: 'Term 3',
                    visibility: true
                },
                {
                    id: 'term_linked_agegroup_assessment.term_d_4',
                    column: 'term_d_4',
                    name: 'Term 4',
                    visibility: true
                },
            ],
            data: [],
        },
        termLinkedAgegroupAssessmentData: {
            edit: false,
            agegroup: null,
            acs_ids: [],
            term_d_1: '0.00',
            term_d_2: '0.00',
            term_d_3: '0.00',
            term_d_4: '0.00',
            tlaa_internal: '100.00',
            tlaa_external: '0.00',
            details: []
        },
        term_linked_agegroup_assessment_detail: null,
        subjects: [],
        centerlics: [],
        selectedCenterlic: null,
        replicateMarksPercentageYearModal: {
            show: false,
            selectedCenterlicToYear: '',
            replicating: false,
            open: () => this.setState({ replicateMarksPercentageYearModal: { ...this.state.replicateMarksPercentageYearModal, show: true } }),
            close: () => this.setState({
                replicateMarksPercentageYearModal: {
                    ...this.state.replicateMarksPercentageYearModal,
                    show: false,
                    selectedCenterlicToYear: '',
                    replicating: false,
                },
            }),
        },
        confirmAlert: {
            show: false,
            action: () => null
        }
    }

    componentDidMount() {
        const { search } = this.state.cdt;
        this.fetchAll({ search });
        this.getCenterlics();

        // OPEN MODAL ON PAGE LOAD : agegroup_id, acs_id
        let getUrlParamData = getUrlParam()
        if (getUrlParamData.agegroup_id && getUrlParamData.acs_id) {
            this.state.modalTermAgegroup.toggle(getUrlParamData.agegroup_id, getUrlParamData.acs_id)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.authData.centerData.center_id != this.props.authData.centerData.center_id) {
            const {
                search,
            } = this.state.cdt;
            this.fetchAll({
                search
            });
        }
    }

    getTermAgegroupAssessment = async (agegroup_id = null, acs_id = null) => {
        if (this.getTermAgegroupAssessmentReq) {
            this.getTermAgegroupAssessmentReq.abort();
        }
        this.getTermAgegroupAssessmentReq = new AbortController();

        const res = await GET('term-agegroup-assessment/get-term-linked-agegroup-assessment',
            {
                signal: this.getTermAgegroupAssessmentReq.signal,
                params: {
                    agegroup_id: (agegroup_id) ? agegroup_id : null,
                    acs_id: (acs_id) ? acs_id : null,
                    centerlic_id: this.state.selectedCenterlic.value
                }
            }
        );
        if (res) {
            let resData = res.data
            let editAgegroup = null
            let editAcs = null

            let agegroup = resData.agegroup.map((v, i) => {
                v.academic_classmain_subject = v.academic_classmain_subject.filter((vv, ii) => {
                    // WHILE EDITING
                    if (acs_id && vv.acs_id == acs_id) {
                        editAcs = { ...vv, label: vv.acs_name, value: vv.acs_id }
                    }

                    let findSubject = resData.data.find((vvv, iii) => vvv.acs_id == vv.acs_id)
                    if (findSubject == undefined) {
                        return vv
                    }
                })

                // WHILE EDITING
                if (agegroup_id && v.agegroup_id == agegroup_id) {
                    editAgegroup = { ...v, label: v.agegroup_code, value: v.agegroup_id }
                }

                return v
            })

            let termLinkedAgegroupAssessmentDataDetails = []
            let examstypegrp = []
            resData.examstypegrp.map((v, i) => {
                let term_linked_agegroup_assessment_detail = (agegroup_id && resData.data.length > 0) ? resData.data[0]['term_linked_agegroup_assessment_detail'] : null
                if (term_linked_agegroup_assessment_detail && term_linked_agegroup_assessment_detail.length > 0) {
                    let f_tlasd = term_linked_agegroup_assessment_detail.find((vv, ii) => vv.examstypegrp_id == v.examstypegrp_id && vv.examstype_id == v.examstype_id)
                    if (f_tlasd) {
                        termLinkedAgegroupAssessmentDataDetails.push({ ...v, tlaa_d_percentage_1: (f_tlasd) ? f_tlasd.tlaa_d_percentage_1 : '0.00', tlaa_d_percentage_2: (f_tlasd) ? f_tlasd.tlaa_d_percentage_2 : '0.00', tlaa_d_percentage_3: (f_tlasd) ? f_tlasd.tlaa_d_percentage_3 : '0.00', tlaa_d_percentage_4: (f_tlasd) ? f_tlasd.tlaa_d_percentage_4 : '0.00', tlaa_d_comment_1: (f_tlasd) ? f_tlasd.tlaa_d_comment_1 : '', tlaa_d_comment_2: (f_tlasd) ? f_tlasd.tlaa_d_comment_2 : '', tlaa_d_comment_3: (f_tlasd) ? f_tlasd.tlaa_d_comment_3 : '', tlaa_d_comment_4: (f_tlasd) ? f_tlasd.tlaa_d_comment_4 : '' })
                    } else {
                        examstypegrp.push({ ...v, label: v.examstype_name, value: v.examstype_id })
                    }
                } else {
                    examstypegrp.push({ ...v, label: v.examstype_name, value: v.examstype_id })
                }
            })

            this.setState({
                agegroup: agegroup,
                examstypegrp: examstypegrp,
                termLinkedAgegroupAssessmentData: {
                    ...this.state.termLinkedAgegroupAssessmentData,
                    edit: (agegroup_id && editAgegroup) ? true : false,
                    agegroup: (agegroup_id && editAgegroup) ? { value: editAgegroup.agegroup_id, label: editAgegroup.agegroup_code, agegroup_id: editAgegroup.agegroup_id, agegroup_code: editAgegroup.agegroup_code, ...editAgegroup } : null,
                    acs_ids: (agegroup_id && editAcs) ? [{ value: editAcs.acs_id, label: editAcs.acs_name, acs_id: editAcs.acs_id, acs_name: editAcs.acs_name, ...editAcs }] : [],
                    term_d_1: (agegroup_id && resData.data.length > 0) ? resData.data[0].term_d_1 : '0.00',
                    term_d_2: (agegroup_id && resData.data.length > 0) ? resData.data[0].term_d_2 : '0.00',
                    term_d_3: (agegroup_id && resData.data.length > 0) ? resData.data[0].term_d_3 : '0.00',
                    term_d_4: (agegroup_id && resData.data.length > 0) ? resData.data[0].term_d_4 : '0.00',
                    tlaa_internal: (agegroup_id && resData.data.length > 0) ? resData.data[0].tlaa_internal : '100.00',
                    tlaa_external: (agegroup_id && resData.data.length > 0) ? resData.data[0].tlaa_external : '0.00',
                    details: termLinkedAgegroupAssessmentDataDetails
                }
            });
        }
    };

    saveTermAgegroupAssessment = async () => {
        if (this.saveTermAgegroupAssessmentReq) {
            this.saveTermAgegroupAssessmentReq.abort()
        }
        this.saveTermAgegroupAssessmentReq = new AbortController

        let termLinkedAgegroupAssessmentData = JSON.parse(JSON.stringify(this.state.termLinkedAgegroupAssessmentData))

        let termTotal = parseFloat(termLinkedAgegroupAssessmentData.term_d_1) + parseFloat(termLinkedAgegroupAssessmentData.term_d_2) + parseFloat(termLinkedAgegroupAssessmentData.term_d_3) + parseFloat(termLinkedAgegroupAssessmentData.term_d_4)
        let total_internal_tlaa_d_percentage_1 = 0;
        let total_internal_tlaa_d_percentage_2 = 0;
        let total_internal_tlaa_d_percentage_3 = 0;
        let total_internal_tlaa_d_percentage_4 = 0;
        let total_external_tlaa_d_percentage_1 = 0;
        let total_external_tlaa_d_percentage_2 = 0;
        let total_external_tlaa_d_percentage_3 = 0;
        let total_external_tlaa_d_percentage_4 = 0;
        let foundExternal = false
        termLinkedAgegroupAssessmentData.details.map((v, i) => {
            if (v.examstypegrp_type2 == 'Internal') {
                total_internal_tlaa_d_percentage_1 += parseFloat(v.tlaa_d_percentage_1)
                total_internal_tlaa_d_percentage_2 += parseFloat(v.tlaa_d_percentage_2)
                total_internal_tlaa_d_percentage_3 += parseFloat(v.tlaa_d_percentage_3)
                total_internal_tlaa_d_percentage_4 += parseFloat(v.tlaa_d_percentage_4)
            } else {
                foundExternal = true
                total_external_tlaa_d_percentage_1 += parseFloat(v.tlaa_d_percentage_1)
                total_external_tlaa_d_percentage_2 += parseFloat(v.tlaa_d_percentage_2)
                total_external_tlaa_d_percentage_3 += parseFloat(v.tlaa_d_percentage_3)
                total_external_tlaa_d_percentage_4 += parseFloat(v.tlaa_d_percentage_4)
            }
        })



        let total_external_internal = parseFloat(termLinkedAgegroupAssessmentData.tlaa_internal) + parseFloat(termLinkedAgegroupAssessmentData.tlaa_external)

        if (!termLinkedAgegroupAssessmentData.agegroup) {
            toast['warning'](t('Please select a Grade!'));
            return
        }
        if (termLinkedAgegroupAssessmentData.acs_ids.length <= 0) {
            toast['warning'](t('Please select at least one Subject!'));
            return
        }
        if (termTotal != 100) {
            toast['warning'](t('All Terms total should be 100!'));
            return
        }
        if (total_internal_tlaa_d_percentage_1 != 100) {
            toast['warning'](t('The total of all Groups in Internal Term 1 should be 100!'));
            return
        }
        if (total_internal_tlaa_d_percentage_2 != 100) {
            toast['warning'](t('The total of all Groups in Internal Term 2 should be 100!'));
            return
        }
        if (total_internal_tlaa_d_percentage_3 != 100) {
            toast['warning'](t('The total of all Groups in Internal Term 3 should be 100!'));
            return
        }
        if (foundExternal && total_external_tlaa_d_percentage_1 != 100) {
            toast['warning'](t('The total of all Groups in External Term 1 should be 100!'));
            return
        }
        if (foundExternal && total_external_tlaa_d_percentage_2 != 100) {
            toast['warning'](t('The total of all Groups in External Term 2 should be 100!'));
            return
        }
        if (foundExternal && total_external_tlaa_d_percentage_3 != 100) {
            toast['warning'](t('The total of all Groups in External Term 3 should be 100!'));
            return
        }
        if (total_external_internal != 100) {
            toast['warning'](t('Internal and External total should be 100!'));
            return
        }
        // if (total_tlaa_d_percentage_4 != 100) {
        //     toast['warning'](t('The total of all Groups in Term 4 should be 100!'));
        //     return
        // }

        termLinkedAgegroupAssessmentData.agegroup_id = termLinkedAgegroupAssessmentData.agegroup?.agegroup_id
        termLinkedAgegroupAssessmentData.acs_ids = termLinkedAgegroupAssessmentData.acs_ids.map((v, i) => v.acs_id)

        let fData = new FormData()
        fData.append('centerlic_id', this.state.selectedCenterlic.value);
        fData.append('termLinkedAgegroupAssessmentData', JSON.stringify(termLinkedAgegroupAssessmentData))
        let res = await POST('term-agegroup-assessment/save', fData, {
            signal: this.saveTermAgegroupAssessmentReq.signal
        })
        if (res) {
            let resData = res.data
            if (resData.type) {
                this.state.modalTermAgegroup.toggle()
                this.fetchAll({
                    search: this.state.cdt.search,
                })
            }
            toast[resData.messageType](t(resData.message));
        }
    }

    replicateTermAgegroupAssessment = async () => {

        if (this.replicateTermAgegroupAssessmentReq) {
            this.replicateTermAgegroupAssessmentReq.abort()
        }
        this.replicateTermAgegroupAssessmentReq = new AbortController

        let termLinkedAgegroupAssessmentData = JSON.parse(JSON.stringify(this.state.termLinkedAgegroupAssessmentData))

        let termTotal = parseFloat(termLinkedAgegroupAssessmentData.term_d_1) + parseFloat(termLinkedAgegroupAssessmentData.term_d_2) + parseFloat(termLinkedAgegroupAssessmentData.term_d_3) + parseFloat(termLinkedAgegroupAssessmentData.term_d_4)
        let total_internal_tlaa_d_percentage_1 = 0;
        let total_internal_tlaa_d_percentage_2 = 0;
        let total_internal_tlaa_d_percentage_3 = 0;
        let total_internal_tlaa_d_percentage_4 = 0;
        let total_external_tlaa_d_percentage_1 = 0;
        let total_external_tlaa_d_percentage_2 = 0;
        let total_external_tlaa_d_percentage_3 = 0;
        let total_external_tlaa_d_percentage_4 = 0;
        let foundExternal = false
        termLinkedAgegroupAssessmentData.details.map((v, i) => {
            if (v.examstypegrp_type2 == 'Internal') {
                total_internal_tlaa_d_percentage_1 += parseFloat(v.tlaa_d_percentage_1)
                total_internal_tlaa_d_percentage_2 += parseFloat(v.tlaa_d_percentage_2)
                total_internal_tlaa_d_percentage_3 += parseFloat(v.tlaa_d_percentage_3)
                total_internal_tlaa_d_percentage_4 += parseFloat(v.tlaa_d_percentage_4)
            } else {
                foundExternal = true
                total_external_tlaa_d_percentage_1 += parseFloat(v.tlaa_d_percentage_1)
                total_external_tlaa_d_percentage_2 += parseFloat(v.tlaa_d_percentage_2)
                total_external_tlaa_d_percentage_3 += parseFloat(v.tlaa_d_percentage_3)
                total_external_tlaa_d_percentage_4 += parseFloat(v.tlaa_d_percentage_4)
            }
        })


        let total_external_internal = parseFloat(termLinkedAgegroupAssessmentData.tlaa_internal) + parseFloat(termLinkedAgegroupAssessmentData.tlaa_external)

        if (!termLinkedAgegroupAssessmentData.agegroup) {
            toast['warning'](t('Please select a Grade!'));
            return
        }
        if (termLinkedAgegroupAssessmentData.acs_ids.length <= 0) {
            toast['warning'](t('Please select at least one Subject!'));
            return
        }
        if (termTotal != 100) {
            toast['warning'](t('All Terms total should be 100!'));
            return
        }
        if (total_internal_tlaa_d_percentage_1 != 100) {
            toast['warning'](t('The total of all Groups in Internal Term 1 should be 100!'));
            return
        }
        if (total_internal_tlaa_d_percentage_2 != 100) {
            toast['warning'](t('The total of all Groups in Internal Term 2 should be 100!'));
            return
        }
        if (total_internal_tlaa_d_percentage_3 != 100) {
            toast['warning'](t('The total of all Groups in Internal Term 3 should be 100!'));
            return
        }
        if (foundExternal && total_external_tlaa_d_percentage_1 != 100) {
            toast['warning'](t('The total of all Groups in External Term 1 should be 100!'));
            return
        }
        if (foundExternal && total_external_tlaa_d_percentage_2 != 100) {
            toast['warning'](t('The total of all Groups in External Term 2 should be 100!'));
            return
        }
        if (foundExternal && total_external_tlaa_d_percentage_3 != 100) {
            toast['warning'](t('The total of all Groups in External Term 3 should be 100!'));
            return
        }
        if (total_external_internal != 100) {
            toast['warning'](t('Internal and External total should be 100!'));
            return
        }
        // if (total_tlaa_d_percentage_4 != 100) {
        //     toast['warning'](t('The total of all Groups in Term 4 should be 100!'));
        //     return
        // }

        termLinkedAgegroupAssessmentData.agegroup_id = termLinkedAgegroupAssessmentData.agegroup?.agegroup_id
        termLinkedAgegroupAssessmentData.acs_ids = this.state.modalTermAgegroup.selectedSubjects.map((v, i) => v.acs_id)

        let fData = new FormData()
        fData.append('centerlic_id', this.state.selectedCenterlic.value);
        fData.append('termLinkedAgegroupAssessmentData', JSON.stringify(termLinkedAgegroupAssessmentData))
        let res = await POST('term-agegroup-assessment/replicate', fData, {
            signal: this.replicateTermAgegroupAssessmentReq.signal
        })
        if (res) {
            let resData = res.data
            if (resData.type) {
                this.state.modalTermAgegroup.toggle()
                this.fetchAll({
                    search: this.state.cdt.search,
                });
                this.setState({
                    confirmAlert: {
                        show: false,
                        action: () => null
                    }
                });
            }
            toast[resData.messageType](t(resData.message));
        }
    }

    setStateFdata = (i, field, value) => {
        let termLinkedAgegroupAssessmentData = this.state.termLinkedAgegroupAssessmentData
        termLinkedAgegroupAssessmentData.details[i][field] = value
        this.setState({ termLinkedAgegroupAssessmentData })
    }

    fetchAll = async (params) => {


        const { selectedCenterlic } = this.state;


        this.setState({
            cdt: {
                ...this.state.cdt,
                fetching: true,
            }
        });

        if (this.getAllReq) {
            this.getAllReq.abort();
        }
        this.getAllReq = new AbortController();

        try {
            const res = await GET('term-agegroup-assessment/get-all', {
                signal: this.getAllReq.signal,
                params: {
                    search: params.search,
                    centerlic_id: selectedCenterlic?.value
                }
            });

            console.log('res', res);

            if (res) {
                let data = res.data.data
                let uniqueAgegroups = uniqueByAttribute2(data, ['agegroup_id']);

                console.log('res.data.data', res.data.data);

                this.setState({
                    cdt: {
                        ...this.state.cdt,
                        fetching: false,
                        search: params.search,
                        data: res.data.data.map((item) => {
                            return {
                                uid: chance.guid(),
                                ...item,
                            }
                        }),
                        uniqueAgegroups: uniqueAgegroups,
                    },
                    subjects: res.data.data.map(v => {
                        return { label: v.acs_name, value: v.acs_id, ...v }
                    }),
                });
            }
        } catch (err) {
            console.log('err', err)
            this.setState({
                cdt: {
                    ...this.state.cdt,
                    fetching: false,
                }
            });

        }
    }

    showHideColumn = (column_index) => {
        const columns = this.state.cdt.columns;
        columns[column_index].visibility = !columns[column_index].visibility;
        this.setState({ ctd: { ...this.state.ctd, columns } })
    }

    exportExcel = async () => {

        const excelData = this.state.cdt.data.map((item) => {
            const row = {};
            this.state.cdt.columns
                .filter((column) => column.visibility)
                .map((column) => {
                    if (column.name !== 'Actions') {
                        row[column.name] = item[column.column];
                    }
                });
            return row;
        });

        const fileName = 'Assessment-Term-Grade Export ' + moment().format('DD-MM-YYYY');
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(excelData);

        const cellStyle = {
            font: {
                bold: true,
            },
        }

        Array.from('A').map((letter) => {
            ws[letter + "1"].s = cellStyle;
        });

        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(data, fileName + fileExtension);
    }

    getCenterlics = async () => {
        if (this.getCenterlicsReq) {
            this.getCenterlicsReq.abort();
        }
        this.getCenterlicsReq = new AbortController();
        const res = await GET('term-agegroup-assessment/get-centerlic',
            {
                signal: this.getCenterlicsReq.signal,
            }
        );
        if (res) {
            let resData = res.data

            const selectedCenterlic = resData
                .filter(v => v.reg_status == 1);

            this.setState({
                centerlics: resData.map((v) => {
                    return {
                        value: v.centerlic_id,
                        label: v.reg_year,
                        ...v
                    }
                }),
                selectedCenterlic: {
                    ...selectedCenterlic[0],
                    value: selectedCenterlic[0].centerlic_id,
                    label: selectedCenterlic[0].reg_year
                }
            })
        }
    }

    renderCell = (column_data, column_id, column_index, dataObj) => {
        const { authData } = this.props;
        const { center_id } = authData.centerData;

        let tdData;

        // --------------------------------------------
        if (column_id == 'tlaa_id') { // Action Buttons
            tdData = <>
                {/* <Button
                    onClick={() => this.delete(dataObj)}
                    variant="danger" size='sm' className='me-1'>
                    <FontAwesomeIcon icon={faTrash} />
                </Button> */}
                <Button
                    onClick={() => this.state.modalTermAgegroup.toggle(dataObj.agegroup_id, dataObj.acs_id)}
                    variant="warning" size='sm' className='me-1'>
                    <FontAwesomeIcon icon={faPencil} />
                </Button>
            </>;
        } else if ([].includes(column_id)) {

        } else {
            tdData = column_data;
        }
        return <td key={column_index}>{tdData}</td>;
    }

    replicateToYear = async () => {
        if (this.replicateToYearReq) {
            this.replicateToYearReq.abort()
        }
        this.replicateToYearReq = new AbortController

        let fData = new FormData()
        fData.append('centerlic_id', this.state.selectedCenterlic.value);
        fData.append('centerlic_id_to', this.state.replicateMarksPercentageYearModal.selectedCenterlicToYear.value);

        let res = await POST('term-agegroup-assessment/replicate-to-year', fData, {
            signal: this.replicateToYearReq.signal
        });

        if (res.data.type) {
            toast.success(t('Replicated Successfully!'));
        } else {
            toast.error(t('Failed to replicate!'));
        }

    }

    replicateMarksPercentage = async () => {

        const { modalTermAgegroup, termLinkedAgegroupAssessmentData } = this.state;

        this.setState({ replicating: true });

        if (this.replicateReq) {
            this.replicateReq.abort();
        }

        this.replicateReq = new AbortController();

        const fData = new FormData();
        fData.append('as_id', termLinkedAgegroupAssessmentData.acs_ids[0].as_id);
        fData.append('acs_id', termLinkedAgegroupAssessmentData.acs_ids[0].acs_id);
        fData.append('selected_grades', JSON.stringify(modalTermAgegroup.selectedAgegroups.map((v, i) => v.agegroup_id)));
        fData.append('term_linked_agegroup_assessment', JSON.stringify(termLinkedAgegroupAssessmentData));
        fData.append('centerlic_id', this.state.selectedCenterlic.value);

        const res = await POST('academic-classmain-subject/replicate-marks-percentage', fData, {
            signal: this.replicateReq.signal,
        });

        if (res.data.type) {
            this.fetchAll({
                search: this.state.cdt.search,
            });
            toast.success(t(res.data.message));
            this.setState({
                replicating: false,
                confirmAlert: {
                    show: false,
                    action: () => null
                }
            });

        } else {
            // toast.error(t(res.data.message));
            handleFormErrors(res.data.data)
            this.setState({ replicating: false });
        }

    }

    render() {
        let { modalTermAgegroup, termLinkedAgegroupAssessmentData, cdt } = this.state

        let termTotal = parseFloat(termLinkedAgegroupAssessmentData.term_d_1) + parseFloat(termLinkedAgegroupAssessmentData.term_d_2) + parseFloat(termLinkedAgegroupAssessmentData.term_d_3) + parseFloat(termLinkedAgegroupAssessmentData.term_d_4)
        let total_internal_tlaa_d_percentage_1 = 0;
        let total_internal_tlaa_d_percentage_2 = 0;
        let total_internal_tlaa_d_percentage_3 = 0;
        let total_internal_tlaa_d_percentage_4 = 0;
        let total_external_tlaa_d_percentage_1 = 0;
        let total_external_tlaa_d_percentage_2 = 0;
        let total_external_tlaa_d_percentage_3 = 0;
        let total_external_tlaa_d_percentage_4 = 0;
        let total_external_internal = parseFloat(termLinkedAgegroupAssessmentData.tlaa_internal) + parseFloat(termLinkedAgegroupAssessmentData.tlaa_external)
        let foundExternal = false

        return (
            <>
                <div className='ps-3'>
                    <Row className='mb-3'>
                        <Col className='pe-0'>
                            <div className='cdt-search' style={{ height: 38, width: '100%', borderRadius: 20 }}>
                                <input type='text'
                                    style={{
                                        paddingLeft: 17
                                    }}
                                    ref={this.searchFieldRef}
                                    defaultValue={this.state.cdt.search}
                                    onChange={(e) => this.fetchAll({
                                        search: e.target.value,
                                    })}
                                    placeholder={t('Search...')} />
                                <button
                                    onClick={() => {
                                        this.fetchAll({
                                            search: '',
                                        });
                                        this.searchFieldRef.current.value = '';
                                    }}>
                                    <FontAwesomeIcon
                                        icon={this.state.cdt.search == '' ? faSearch : faXmark}
                                        color={brand_colors[this.props.defaultTheme.theme_id].color18}
                                    />
                                </button>
                            </div>
                        </Col>
                        <Col md={'auto'}>
                            <Button variant='info' style={{ borderRadius: 20 }} onClick={() => modalTermAgegroup.toggle()}>
                                {t('Assign Percentage')}
                                <FontAwesomeIcon icon={faPlus} className='ms-2' />
                            </Button>
                        </Col>
                    </Row>
                    <div className='grey-section' style={{ borderRadius: 20, padding: 15 }}>
                        <Row>
                            <Col md={6}>
                                <div style={{ width: 270, float: 'left', marginRight: 10 }}>
                                    <Select
                                        placeholder={t('Select Year')}
                                        options={this.state.centerlics}
                                        onChange={(obj) => this.setState({
                                            selectedCenterlic: obj
                                        }, () => {
                                            this.fetchAll({
                                                search: ''
                                            })
                                        })}
                                        value={this.state.selectedCenterlic}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 99999999999999,
                                            }),
                                            control: styles => ({
                                                ...styles,
                                                borderRadius: 10
                                            }),
                                        }}
                                        formatOptionLabel={option => (
                                            <div>
                                                {option.label}
                                                {option.reg_status == 1 &&
                                                    <Badge className='ms-1' style={{ position: 'relative', top: -1 }} bg={'success'}>{t('ACTIVE')}</Badge>
                                                }
                                            </div>
                                        )}
                                    />
                                </div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                <Button variant="warning" style={{ borderRadius: 10 }} onClick={() => this.state.replicateMarksPercentageYearModal.open()}>
                                    <FontAwesomeIcon icon={faCopy} className='ms-2' /> {t("Replicate To Another Year")}
                                </Button>
                            </Col>
                        </Row>
                        <Accordion className='marks-percentage-accordion'
                            // Waqti Jugar
                            defaultActiveKey={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50]}
                            alwaysOpen>
                            {!this.state.cdt.fetching && this.state.cdt.data.length !== 0 &&
                                this.state.cdt.uniqueAgegroups.map((v, i) => (
                                    <Accordion.Item eventKey={i} key={i}>
                                        <Accordion.Header>
                                            <div style={{
                                                border: '#538DEE 1px solid',
                                                borderRadius: 10,
                                                color: '#538DEE',
                                                padding: 5,
                                                fontWeight: 'bold',
                                                marginRight: 10,
                                                fontSize: 14
                                            }}>{v.gcycle_desc}</div>
                                            <strong>{v.agegroup_code}</strong>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Row className='px-1'>
                                                {this.state.cdt.data.map((vv, ii) => {
                                                    if (vv.agegroup_id == v.agegroup_id) {
                                                        return <Col md={3} className='p-0' key={ii}>
                                                            <div className='cursor-pointer' style={{ fontSize: 18, margin: 7 }} onClick={() => modalTermAgegroup.toggle(vv.agegroup_id, vv.acs_id)}>
                                                                <div style={{ width: '100%', padding: 12, }} className={(vv.tlaa_id) ? 'badge badge-light-success' : 'badge badge-light-danger'}>
                                                                    <div className='d-flex'>
                                                                        <FontAwesomeIcon icon={(vv.tlaa_id) ? faCheckCircle : faExclamationCircle} className={'me-1'} />
                                                                        <div>{vv.acs_name}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    }
                                                })}
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                        </Accordion>
                    </div>
                </div>
                {/* modalTermAgegroup */}
                <Modal show={modalTermAgegroup.show} onHide={() => modalTermAgegroup.toggle()} size="xl" backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTermAgegroup.title} ({this.state.selectedCenterlic?.label})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='custom-styled-form'>
                        {modalTermAgegroup.show &&
                            <div className='d-flex flex-column'>
                                <div className='d-flex flex-row flex-wrap align-items-center mb-3 border-bottom pb-2'>
                                    <div style={{ minWidth: 200 }}>
                                        {(termLinkedAgegroupAssessmentData.edit)
                                            ? <div style={{ fontSize: 20, fontWeight: '600' }}>Grade: {termLinkedAgegroupAssessmentData.agegroup.label}</div>
                                            : <Select
                                                placeholder={t('-- Select Grade--')}
                                                options={this.state.agegroup.map((v, i) => { return { label: v.agegroup_code, value: v.agegroup_id, ...v } })}
                                                onChange={(obj) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, agegroup: obj, acs_ids: [] } })}
                                                value={termLinkedAgegroupAssessmentData.agegroup}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999999999999 }) }}
                                            />
                                        }
                                    </div>
                                    <div className='ms-2'>
                                        {(termLinkedAgegroupAssessmentData.edit)
                                            ? <div style={{ fontSize: 20, fontWeight: '600' }}>Subject: {termLinkedAgegroupAssessmentData.acs_ids[0].label}</div>
                                            : <Select
                                                isMulti={true}
                                                closeMenuOnSelect={false}
                                                placeholder={t('-- Select Subjects--')}
                                                options={this.state.termLinkedAgegroupAssessmentData.agegroup?.academic_classmain_subject.map((v, i) => { return { label: v.acs_name, value: v.acs_id, ...v } })}
                                                onChange={(obj) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, acs_ids: obj } })}
                                                value={termLinkedAgegroupAssessmentData.acs_ids}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999999999999 }) }}
                                            />
                                        }
                                    </div>

                                </div>
                                {termLinkedAgegroupAssessmentData.edit &&
                                    <>
                                        <Row className='mb-2'>
                                            <Col className='pe-0 position-relative'>
                                                <button style={{
                                                    fontSize: 10,
                                                    fontWeight: 'bold',
                                                    borderRadius: 10,
                                                    position: 'absolute',
                                                    right: 7,
                                                    top: 7,
                                                    zIndex: 9999,
                                                }}
                                                    onClick={() => {
                                                        let new_modalTermAgegroup = this.state.modalTermAgegroup
                                                        new_modalTermAgegroup.selectedSubjects = this.state.subjects.filter(item => item.agegroup_id == termLinkedAgegroupAssessmentData.agegroup.agegroup_id);
                                                        this.setState({ modalTermAgegroup: new_modalTermAgegroup });
                                                    }}
                                                    className='btn btn-sm btn-warning'>SELECT ALL</button>
                                                <Select
                                                    placeholder={t('Select Subjects')}
                                                    isMulti={true}
                                                    closeMenuOnSelect={false}
                                                    value={this.state.modalTermAgegroup.selectedSubjects}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999
                                                        }),
                                                        control: styles => ({
                                                            ...styles,
                                                            paddingRight: 75
                                                        }),
                                                    }}
                                                    options={this.state.subjects.filter(item => item.agegroup_id == termLinkedAgegroupAssessmentData.agegroup.agegroup_id)}
                                                    onChange={(obj) => {
                                                        let new_modalTermAgegroup = this.state.modalTermAgegroup
                                                        new_modalTermAgegroup.selectedSubjects = obj;
                                                        this.setState({ modalTermAgegroup: modalTermAgegroup });
                                                    }}
                                                />
                                            </Col>
                                            <Col md={'auto'}>
                                                <Button
                                                    disabled={this.state.modalTermAgegroup.selectedSubjects.length == 0}
                                                    style={{
                                                        height: 38,
                                                        backgroundColor: '#BFEBFA',
                                                        borderColor: '#BFEBFA',
                                                        color: '#000',
                                                        width: 270,
                                                    }} size="sm" variant='light' onClick={() => this.setState({
                                                        confirmAlert: {
                                                            show: true,
                                                            action: () =>
                                                                this.replicateTermAgegroupAssessment()
                                                        }
                                                    })}><FontAwesomeIcon icon={faCopy} className='me-1' /> {t('Replicate for Selected Subjects')}
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row className='mb-3'>
                                            <Col className='pe-0 position-relative'>
                                                <button style={{
                                                    fontSize: 10,
                                                    fontWeight: 'bold',
                                                    borderRadius: 10,
                                                    position: 'absolute',
                                                    right: 7,
                                                    top: 7,
                                                    zIndex: 9999,
                                                }}
                                                    onClick={() => {
                                                        let new_modalTermAgegroup = this.state.modalTermAgegroup
                                                        new_modalTermAgegroup.selectedAgegroups = this.state.cdt.uniqueAgegroups.map(item => {
                                                            return {
                                                                ...item,
                                                                value: item.agegroup_id,
                                                                label: item.agegroup_code
                                                            }
                                                        });
                                                        this.setState({ modalTermAgegroup: new_modalTermAgegroup });
                                                    }}
                                                    className='btn btn-sm btn-warning'>SELECT ALL</button>
                                                <Select
                                                    placeholder={t('Select Grades')}
                                                    isMulti={true}
                                                    closeMenuOnSelect={false}
                                                    value={this.state.modalTermAgegroup.selectedAgegroups}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999
                                                        }),
                                                        control: styles => ({
                                                            ...styles,
                                                            paddingRight: 75
                                                        }),
                                                    }}
                                                    options={this.state.cdt.uniqueAgegroups.map(item => {
                                                        return {
                                                            ...item,
                                                            value: item.agegroup_id,
                                                            label: item.agegroup_code
                                                        }
                                                    })}
                                                    onChange={(obj) => {
                                                        let new_modalTermAgegroup = this.state.modalTermAgegroup
                                                        new_modalTermAgegroup.selectedAgegroups = obj;
                                                        this.setState({ modalTermAgegroup: modalTermAgegroup });
                                                    }}
                                                />
                                            </Col>
                                            <Col md={'auto'}>
                                                <Button disabled={this.state.modalTermAgegroup.selectedAgegroups.length == 0}
                                                    style={{
                                                        height: 38,
                                                        backgroundColor: '#B7DFB0',
                                                        borderColor: '#B7DFB0',
                                                        color: '#000',
                                                        width: 270,
                                                    }} size="sm" variant='light' onClick={() => this.setState({
                                                        confirmAlert: {
                                                            show: true,
                                                            action: () => this.replicateMarksPercentage()
                                                        }
                                                    })}><FontAwesomeIcon icon={faCopy} className='me-1' /> {t('Replicate for Selected Grades')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                }
                                <div>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}></th>
                                                <th style={{ width: '33.34%' }} className="table-primary">
                                                    <div className='d-flex flex-row align-items-center'>
                                                        <div className='me-2' style={{ fontSize: 20, textAlign: 'center' }}>Internal</div>
                                                        <InputGroup>
                                                            <Form.Control placeholder={t('%')}
                                                                value={termLinkedAgegroupAssessmentData.tlaa_internal}
                                                                onChange={(e) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, tlaa_internal: e.target.value } })} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                    </div>
                                                </th>
                                                <th style={{ width: '33.34%' }} className="table-danger">
                                                    <div className='d-flex flex-row align-items-center'>
                                                        <div className='me-2' style={{ fontSize: 20, textAlign: 'center' }}>External</div>
                                                        <InputGroup>
                                                            <Form.Control placeholder={t('%')}
                                                                value={termLinkedAgegroupAssessmentData.tlaa_external}
                                                                onChange={(e) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, tlaa_external: e.target.value } })} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                    </div>
                                                </th>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
                                                    <div className='d-flex'>
                                                        <div style={{ flex: 1, textAlign: 'center' }}>=</div>
                                                        <div style={{
                                                            backgroundColor: (total_external_internal == 100) ? '#D7FFE8' : '#FCDEDE',
                                                            color: (total_external_internal == 100) ? '#48CF48' : '#F45959',
                                                            flex: 1,
                                                            padding: 5,
                                                            textAlign: 'center',
                                                            borderRadius: 5
                                                        }}>{total_external_internal}%</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                    </Table>
                                </div>
                                <div>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}></th>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
                                                    <div style={{ fontSize: 20, textAlign: 'center' }}>Term 1</div>
                                                    <InputGroup>
                                                        <Form.Control placeholder={t('%')}
                                                            value={termLinkedAgegroupAssessmentData.term_d_1}
                                                            onChange={(e) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, term_d_1: e.target.value } })} />
                                                        <InputGroup.Text>%</InputGroup.Text>
                                                    </InputGroup>
                                                </th>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
                                                    <div style={{ fontSize: 20, textAlign: 'center' }}>Term 2</div>
                                                    <InputGroup>
                                                        <Form.Control placeholder={t('%')}
                                                            value={termLinkedAgegroupAssessmentData.term_d_2}
                                                            onChange={(e) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, term_d_2: e.target.value } })} />
                                                        <InputGroup.Text>%</InputGroup.Text>
                                                    </InputGroup>
                                                </th>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
                                                    <div style={{ fontSize: 20, textAlign: 'center' }}>Term 3</div>
                                                    <InputGroup>
                                                        <Form.Control placeholder={t('%')}
                                                            value={termLinkedAgegroupAssessmentData.term_d_3}
                                                            onChange={(e) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, term_d_3: e.target.value } })} />
                                                        <InputGroup.Text>%</InputGroup.Text>
                                                    </InputGroup>
                                                </th>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
                                                    <div style={{ fontSize: 20, textAlign: 'center' }}>Term 4</div>
                                                    <InputGroup>
                                                        <Form.Control placeholder={t('%')}
                                                            value={termLinkedAgegroupAssessmentData.term_d_4}
                                                            onChange={(e) => this.setState({ termLinkedAgegroupAssessmentData: { ...termLinkedAgegroupAssessmentData, term_d_4: e.target.value } })} />
                                                        <InputGroup.Text>%</InputGroup.Text>
                                                    </InputGroup>
                                                </th>
                                                <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
                                                    <div className='d-flex'>
                                                        <div style={{ flex: 1, textAlign: 'center' }}>=</div>
                                                        <div style={{
                                                            backgroundColor: (termTotal == 100) ? '#D7FFE8' : '#FCDEDE',
                                                            color: (termTotal == 100) ? '#48CF48' : '#F45959',
                                                            flex: 1,
                                                            padding: 5,
                                                            textAlign: 'center',
                                                            borderRadius: 5
                                                        }}>{termTotal}%</div>
                                                    </div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td colSpan={6} style={{ backgroundColor: '#f2f2f2' }}>
                                                    <div className='d-flex flex-row justify-content-end'>
                                                        <div className='me-2' style={{ width: 500 }}>
                                                            <Select
                                                                placeholder={t('-- Add New Row -- ')}
                                                                options={this.state.examstypegrp.filter((v, i) => {
                                                                    let findUsed = termLinkedAgegroupAssessmentData.details.find((vv, ii) => vv.examstype_id == v.examstype_id)
                                                                    if (!findUsed) {
                                                                        return v
                                                                    }
                                                                })}
                                                                onChange={(obj) => this.setState({ term_linked_agegroup_assessment_detail: obj })}
                                                                value={this.state.term_linked_agegroup_assessment_detail}
                                                                menuPortalTarget={document.body}
                                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999999999999 }) }}
                                                                formatOptionLabel={option => {
                                                                    console.log('option', option);
                                                                    let find_type = this.state.DDL_examstypegrp_types.find((vv) => vv.value == option.examstypegrp_type)
                                                                    let find_type2 = this.state.DDL_examstypegrp_types2.find((vv) => vv.value == option.examstypegrp_type2)
                                                                    return <div>
                                                                        <div>{option.examstype_name} ({option.examstypegrp_name})</div>
                                                                        <span style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type.color, 0.2), color: find_type.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{option.examstypegrp_type}</span>
                                                                        <span className='ms-1' style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type2.color, 0.2), color: find_type2.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{option.examstypegrp_type2}</span>
                                                                    </div>
                                                                }}
                                                            />
                                                        </div>
                                                        <Button variant="primary" onClick={() => {
                                                            if (!this.state.term_linked_agegroup_assessment_detail) {
                                                                toast['warning'](t('Please select Type first!'))
                                                                return false
                                                            }
                                                            let termLinkedAgegroupAssessmentDataNew = termLinkedAgegroupAssessmentData
                                                            termLinkedAgegroupAssessmentDataNew.details.push({ ...this.state.term_linked_agegroup_assessment_detail, tlaa_d_percentage_1: '0.00', tlaa_d_percentage_2: '0.00', tlaa_d_percentage_3: '0.00', tlaa_d_percentage_4: '0.00', tlaa_d_comment_1: '', tlaa_d_comment_2: '', tlaa_d_comment_3: '', tlaa_d_comment_4: '', })
                                                            this.setState({
                                                                termLinkedAgegroupAssessmentData: termLinkedAgegroupAssessmentDataNew, term_linked_agegroup_assessment_detail: null
                                                            })
                                                        }}>
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </Button>

                                                    </div>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* ONLY INTERNAL */}
                                            {termLinkedAgegroupAssessmentData.details.map((v, i) => {
                                                if (v.examstypegrp_type2 != 'Internal') {
                                                    return null
                                                }
                                                total_internal_tlaa_d_percentage_1 += parseFloat(v.tlaa_d_percentage_1)
                                                total_internal_tlaa_d_percentage_2 += parseFloat(v.tlaa_d_percentage_2)
                                                total_internal_tlaa_d_percentage_3 += parseFloat(v.tlaa_d_percentage_3)
                                                total_internal_tlaa_d_percentage_4 += parseFloat(v.tlaa_d_percentage_4)
                                                let find_type = this.state.DDL_examstypegrp_types.find((vv) => vv.value == v.examstypegrp_type)
                                                let find_type2 = this.state.DDL_examstypegrp_types2.find((vv) => vv.value == v.examstypegrp_type2)
                                                return <tr className='table-primary'>
                                                    <td>
                                                        <div>{v.examstype_name} ({v.examstypegrp_name})</div>
                                                        <span className='me-1' style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type2.color, 0.2), color: find_type2.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{v.examstypegrp_type2}</span>
                                                        <span style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type.color, 0.2), color: find_type.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{v.examstypegrp_type}</span>
                                                        <div>
                                                            <FontAwesomeIcon icon={faMinusCircle} style={{ color: brand_colors[this.props.defaultTheme.theme_id].color11 }} className='cursor-pointer' title={t('Remove')} onClick={() => {
                                                                let termLinkedAgegroupAssessmentDataNew = termLinkedAgegroupAssessmentData
                                                                termLinkedAgegroupAssessmentDataNew.details.splice(i, 1)
                                                                this.setState({ termLinkedAgegroupAssessmentData: termLinkedAgegroupAssessmentDataNew })
                                                            }} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_1}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_1', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group >
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_1}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_1', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_2}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_2', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group>
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_2}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_2', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_3}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_3', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group>
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_3}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_3', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_4}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_4', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group>
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_4}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_4', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            })}
                                            <tr>
                                                <td></td>
                                                <td>
                                                    <div style={{
                                                        backgroundColor: (total_internal_tlaa_d_percentage_1 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                        color: (total_internal_tlaa_d_percentage_1 == 100) ? '#48CF48' : '#F45959',
                                                        flex: 1,
                                                        padding: 5,
                                                        textAlign: 'center',
                                                        borderRadius: 5,
                                                        fontWeight: 'bold'
                                                    }}>{total_internal_tlaa_d_percentage_1}%</div>
                                                </td>
                                                <td>
                                                    <div style={{
                                                        backgroundColor: (total_internal_tlaa_d_percentage_2 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                        color: (total_internal_tlaa_d_percentage_2 == 100) ? '#48CF48' : '#F45959',
                                                        flex: 1,
                                                        padding: 5,
                                                        textAlign: 'center',
                                                        borderRadius: 5,
                                                        fontWeight: 'bold'
                                                    }}>{total_internal_tlaa_d_percentage_2}%</div>
                                                </td>
                                                <td>
                                                    <div style={{
                                                        backgroundColor: (total_internal_tlaa_d_percentage_3 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                        color: (total_internal_tlaa_d_percentage_3 == 100) ? '#48CF48' : '#F45959',
                                                        flex: 1,
                                                        padding: 5,
                                                        textAlign: 'center',
                                                        borderRadius: 5,
                                                        fontWeight: 'bold'
                                                    }}>{total_internal_tlaa_d_percentage_3}%</div>
                                                </td>
                                                <td>
                                                    <div style={{
                                                        backgroundColor: (total_internal_tlaa_d_percentage_4 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                        color: (total_internal_tlaa_d_percentage_4 == 100) ? '#48CF48' : '#F45959',
                                                        flex: 1,
                                                        padding: 5,
                                                        textAlign: 'center',
                                                        borderRadius: 5,
                                                        fontWeight: 'bold'
                                                    }}>{total_internal_tlaa_d_percentage_4}%</div>
                                                </td>
                                                <td></td>
                                            </tr>
                                            {/* ONLY EXTERNAL */}
                                            {termLinkedAgegroupAssessmentData.details.map((v, i) => {
                                                if (v.examstypegrp_type2 != 'External') {
                                                    return null
                                                }
                                                foundExternal = true
                                                total_external_tlaa_d_percentage_1 += parseFloat(v.tlaa_d_percentage_1)
                                                total_external_tlaa_d_percentage_2 += parseFloat(v.tlaa_d_percentage_2)
                                                total_external_tlaa_d_percentage_3 += parseFloat(v.tlaa_d_percentage_3)
                                                total_external_tlaa_d_percentage_4 += parseFloat(v.tlaa_d_percentage_4)
                                                let find_type = this.state.DDL_examstypegrp_types.find((vv) => vv.value == v.examstypegrp_type)
                                                let find_type2 = this.state.DDL_examstypegrp_types2.find((vv) => vv.value == v.examstypegrp_type2)
                                                return <tr className='table-danger'>
                                                    <td>
                                                        <div>{v.examstype_name} ({v.examstypegrp_name})</div>
                                                        <span className='me-1' style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type2.color, 0.2), color: find_type2.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{v.examstypegrp_type2}</span>
                                                        <span style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type.color, 0.2), color: find_type.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{v.examstypegrp_type}</span>
                                                        <div>
                                                            <FontAwesomeIcon icon={faMinusCircle} style={{ color: brand_colors[this.props.defaultTheme.theme_id].color11 }} className='cursor-pointer' title={t('Remove')} onClick={() => {
                                                                let termLinkedAgegroupAssessmentDataNew = termLinkedAgegroupAssessmentData
                                                                termLinkedAgegroupAssessmentDataNew.details.splice(i, 1)
                                                                this.setState({ termLinkedAgegroupAssessmentData: termLinkedAgegroupAssessmentDataNew })
                                                            }} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_1}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_1', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group >
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_1}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_1', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_2}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_2', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group>
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_2}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_2', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_3}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_3', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group>
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_3}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_3', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>
                                                        <InputGroup className="mb-1">
                                                            <Form.Control placeholder={t('%')}
                                                                value={v.tlaa_d_percentage_4}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_percentage_4', e.target.value)} />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                        <Form.Group>
                                                            <Form.Control type="text" placeholder={t('Comment')}
                                                                value={v.tlaa_d_comment_4}
                                                                onChange={(e) => this.setStateFdata(i, 'tlaa_d_comment_4', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            })}
                                            {foundExternal &&
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <div style={{
                                                            backgroundColor: (total_external_tlaa_d_percentage_1 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                            color: (total_external_tlaa_d_percentage_1 == 100) ? '#48CF48' : '#F45959',
                                                            flex: 1,
                                                            padding: 5,
                                                            textAlign: 'center',
                                                            borderRadius: 5,
                                                            fontWeight: 'bold'
                                                        }}>{total_external_tlaa_d_percentage_1}%</div>
                                                    </td>
                                                    <td>
                                                        <div style={{
                                                            backgroundColor: (total_external_tlaa_d_percentage_2 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                            color: (total_external_tlaa_d_percentage_2 == 100) ? '#48CF48' : '#F45959',
                                                            flex: 1,
                                                            padding: 5,
                                                            textAlign: 'center',
                                                            borderRadius: 5,
                                                            fontWeight: 'bold'
                                                        }}>{total_external_tlaa_d_percentage_2}%</div>
                                                    </td>
                                                    <td>
                                                        <div style={{
                                                            backgroundColor: (total_external_tlaa_d_percentage_3 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                            color: (total_external_tlaa_d_percentage_3 == 100) ? '#48CF48' : '#F45959',
                                                            flex: 1,
                                                            padding: 5,
                                                            textAlign: 'center',
                                                            borderRadius: 5,
                                                            fontWeight: 'bold'
                                                        }}>{total_external_tlaa_d_percentage_3}%</div>
                                                    </td>
                                                    <td>
                                                        <div style={{
                                                            backgroundColor: (total_external_tlaa_d_percentage_4 == 100) ? '#D7FFE8' : '#FCDEDE',
                                                            color: (total_external_tlaa_d_percentage_4 == 100) ? '#48CF48' : '#F45959',
                                                            flex: 1,
                                                            padding: 5,
                                                            textAlign: 'center',
                                                            borderRadius: 5,
                                                            fontWeight: 'bold'
                                                        }}>{total_external_tlaa_d_percentage_4}%</div>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            }
                                        </tbody>

                                    </Table>
                                </div>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => modalTermAgegroup.toggle()}>
                            {t('Close')}
                        </Button>
                        <Button variant="primary" onClick={modalTermAgegroup.save}>
                            {t('Save Changes')}
                        </Button>
                    </Modal.Footer>
                </Modal >

                <Modal show={this.state.replicateMarksPercentageYearModal.show} onHide={() => this.state.replicateMarksPercentageYearModal.close()} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('Replicate Marks Percentage To Another Year')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={4} className='d-flex align-items-center'><strong className='me-2'>{t('From Year:')}</strong> {this.state.selectedCenterlic?.label}</Col>
                            <Col className='d-flex align-items-center'><strong className='me-2'>{t('To Year:')}</strong>
                                <div style={{ width: 200 }}>
                                    <Select
                                        placeholder={t('Select Year')}
                                        options={this.state.centerlics.filter(item => item.value != this.state.selectedCenterlic.value)}
                                        onChange={(obj) => this.setState({
                                            replicateMarksPercentageYearModal: {
                                                ...this.state.replicateMarksPercentageYearModal,
                                                selectedCenterlicToYear: obj
                                            }
                                        })}
                                        value={this.state.replicateMarksPercentageYearModal.selectedCenterlicToYear}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 99999999999999,
                                            })
                                        }}
                                        formatOptionLabel={option => (
                                            <div>
                                                {option.label}
                                                {option.reg_status == 1 &&
                                                    <Badge className='ms-1' style={{ position: 'relative', top: -1 }} bg={'success'}>{t('ACTIVE')}</Badge>
                                                }
                                            </div>
                                        )}
                                    />
                                </div>
                            </Col>
                            <Col md={'auto'}><Button onClick={() => this.replicateToYear()}
                                disabled={!this.state.replicateMarksPercentageYearModal.selectedCenterlicToYear}>{t('Replicate')}</Button></Col>
                        </Row>
                    </Modal.Body>
                </Modal>

                <SweetAlert show={this.state.deleteModal.show} warning showCancel confirmBtnText={t('Yes, delete it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.deleteModal.action} onCancel={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: false, id: 0, action: () => { } } })} focusCancelBtn>
                    {t('Confirm Delete!')}
                </SweetAlert>

                <SweetAlert show={this.state.confirmAlert.show} warning showCancel confirmBtnText={t('Yes, replicate it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.confirmAlert.action} onCancel={() => this.setState({ confirmAlert: { ...this.state.confirmAlert, show: false, action: () => null } })} focusCancelBtn>
                    {t('This function will replicate the records for the targeted subject(s) and Grade(s) if their Records are empty this Function is irrevocable. Edit should then be manual.')}
                </SweetAlert>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    defaultLanguage: state.language.defaultLanguage,
    defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(TermAgegroupAssessment);
